module.exports = __webpack_public_path__ + "img/horse.c473fc09.png";